<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/configuration")
            i.fa.fa-cogs
            span.ml-1 {{ $t("ui.configuration") }}
        b-breadcrumb-item
          router-link(to="/configuration/jobcontrolsport")
            i.fas.fa-tasks
            span.ml-1 {{ $t("ui.job_control_sport") }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row.mb-1(style="width: 30%;")
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $tc('ui.sports', 1) }}
                b-form-select(v-model="sportType")
                  option(v-for="sportInfo in sportOption" v-bind:value="sportInfo.value")
                    | {{ sportInfo.text }}
          div.card-body.p-1
            .clusterize
              .clusterize-scroll
                table.tablex(style="width: auto;" v-columns-resizable).mb-5
                  thead
                    tr
                      th.sticky-position
                        span {{ $tc("ui.sports", 1) }}
                      th.sticky-position
                        span {{ $tc("ui.providers", 1) }}
                  tbody.clusterize-content
                    tr(v-for="(item, index) in filterJobControlList")
                      td
                        span.text-uppercase {{ item.sport_type }}
                      td
                        select(@change="changedProvider(item, $event)" :value="item.provider_id")
                          option(value="ALL") {{ $t("ui.all") }}
                          option(value="SBO") {{ $t("ui.sbo") }}
                          option(value="IBC") {{ $t("ui.ibc") }}
                          //- option(value="CMD" disabled) {{ $t("ui.cmd") }}
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      onContentReady: function(e) {
        if (!collapsed) {
          e.component.expandRow(e.component.getKeyByRowIndex(0));
          collapsed = true;
        }
      },
      sportList: [],
      jobControlList: [],
      sportType: ""
    }
  },
  computed: {
    sportOption: function() {
      var list = [];

      list.push({
        text: "ALL SPORTS",
        value: ""
      });

      for (var i = 0; i < this.sportList.length; i++) {
        list.push({
          text: this.sportList[i].sport_type,
          value: this.sportList[i].sport_type
        });
      }

      return list;
    },
    filterJobControlList() {
      return this.jobControlList
        .filter(item => {
          if (this.sportType == "")
            return item.sport_type.indexOf(this.sportType) > -1;
          else
            return item.sport_type == this.sportType;
        })
        .sort((a, b) => {
          return a.sport_type > b.sport_type ? 1 : -1;
        });
    }
  },
  mounted: function() {
    this.getSportList();
    this.getJobControlList();
  },
  methods: {
    getSportList() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.jobcontrol
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getJobControlList() {
      this.jobControlList = [];
      
      let url = config.jobControlSportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.jobcontrolsport
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.jobControlList = response.data.tbl_job_control_sport_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedProvider: function(item, eventStatus) {
      let url = config.editJobControlSportUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.jobcontrolsport,
        sport_id: item.sport_id,
        provider_id: eventStatus.srcElement.value
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.provider_id = eventStatus.srcElement.value;
                this.$helpers.showDialog(this.$tc("ui.providers", 1), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
  }
}
</script>